import { configureStore } from "@reduxjs/toolkit";
import roomNateSlice from "../Slices/roomNateSlice";
import { apiRoomNate } from "../Slices/roomNateApis"
import { constantApis } from "../Slices/roomNateConstantApis";

const store = configureStore({
  reducer: {
    [apiRoomNate.reducerPath]:apiRoomNate.reducer,
    roomNateSlice,
    [constantApis.reducerPath]:constantApis.reducer,
  },
  middleware: (middleware) => middleware().concat(apiRoomNate.middleware, constantApis.middleware),
});

export default store;
